export const isSameDomain = (currentUrl?: string, url?: string): boolean => {
  if (!currentUrl || !url) {
    return false;
  }

  const currentDomain = new URL(currentUrl).hostname;
  const domain = new URL(url).hostname;

  return currentDomain === domain;
};
